import React, { useEffect, useState } from 'react';

interface ScrollSpyProps {
  children: React.ReactNode;
}

const ScrollSpy: React.FC<ScrollSpyProps> = ({ children }) => {
  const [activeSection, setActiveSection] = useState<string>('');

  useEffect(() => {
    const sections = ['services', 'about', 'contact'];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.5 }
    );

    sections.forEach((section) => {
      const element = document.getElementById(section);
      if (element) {
        observer.observe(element);
      }
    });

    return () => {
      sections.forEach((section) => {
        const element = document.getElementById(section);
        if (element) {
          observer.unobserve(element);
        }
      });
    };
  }, []);

  useEffect(() => {
    const navLinks = document.querySelectorAll('.nav-links a');
    navLinks.forEach((link) => {
      if (link.getAttribute('href') === `#${activeSection}`) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
  }, [activeSection]);

  return <>{children}</>;
};

export default ScrollSpy; 